import React from 'react';
import AudioInputList from './AudioInputList';
import AudioOutputList from './AudioOutputList';
import VideoInputList from './VideoInputList';

export default function Settings({ onOptionsClicked}) {
    return (<>
        <div className="modal-video-visit-settings"
        >
            <div className="row">
                <div className="col-12 settings-header">
                    <div className="heading">Device Settings</div>
                    <button type="button" className="btn btn-icon-only" onClick={() => onOptionsClicked()}><span className="icon-close" /></button>
                </div>
            </div>
            <AudioOutputList />
            <AudioInputList />
            <VideoInputList />
        </div></>);
}
